import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {View} from 'react-native';
import {Text} from '../../../../../../shared/components/text';
import {NavigationRouteProps, Screens} from '../../../../../../shared/routing/model';
import {useNavigation, useRoute} from '@react-navigation/native';
import {useAccountLinker} from '../../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';
import {Button} from '../../../../../../shared/components/button';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {useTheme} from '../../../../../../shared/theme';
import {ProfileLinkedAccountStatus} from '../../../../../../shared/models/linkAccount';
import {LoadableContent} from '../../../../../../shared/components/loadableContent';
import {capitalizeLastWord} from '../../../../../../shared/utils/text';
import {useAccountLinkConfirmationDialog} from '../../../../../../shared/hooks/useConfirmationDialog';
import {CounterpartyLinkedProfile} from '../../../../../../shared/hooks/useAccountLinkerHook/Types';

export function LinkedAccountItemDetails() {
  const route: NavigationRouteProps<{'linkedAccount-id'?: string}> = useRoute();
  const appId = route?.params?.['linkedAccount-id'];
  const {linkedAccounts, acceptLinkingRequest, declineLinkRequest, setIsLoading} = useAccountLinker();
  const [currAccount] = appId ? linkedAccounts.filter((account) => account.id === +appId) : [];
  const [currAccountState, setCurrAccountState] = useState<CounterpartyLinkedProfile | undefined>(currAccount);
  const currAccountId = useMemo(() => {
    return currAccount?.id?.toString();
  }, [currAccount]);

  const nav = useNavigation();

  const memoizedAcceptLinkingRequest = useCallback(acceptLinkingRequest, []);
  const memoizedDeclineLinkRequest = useCallback(declineLinkRequest, []);

  const confirmDeclineDialog = useAccountLinkConfirmationDialog({
    confirmationMessage: 'Подтвердите отмену подключения аккаунта',
    confirmedAction: memoizedDeclineLinkRequest,
    currentAccountSetter: setCurrAccountState,
    id: currAccountId,
  });
  const handleDeclineClick = () => {
    confirmDeclineDialog();
  };

  const confirmAcceptDialog = useAccountLinkConfirmationDialog({
    confirmationMessage: 'Подтвердите подключение аккаунта',
    confirmedAction: memoizedAcceptLinkingRequest,
    id: currAccountId,
  });
  const handleAcceptLinkingAccount = () => {
    confirmAcceptDialog();
  };

  useEffect(() => {
    if (currAccountState === undefined) {
      setIsLoading(false);
      nav.navigate(Screens.Profile);
      nav.navigate(Screens.ProfileLinkedAccounts);
    }
  }, [currAccountState]);

  const _theme = useTheme();
  const styles = useStyles(({theme}) => {
    return {
      h2: {
        ...theme.fonts.h2,
      },
      h3: {
        ...theme.fonts.h3,
      },
      h4: {
        ...theme.fonts.h4,
      },
      h6: {
        ...theme.fonts.h6,
      },
      button: {
        padding: 0,
        width: 'auto',
      },
    };
  });

  const nonActivatedStatuses = [5, 6, undefined];

  const isNeedActivation =
    currAccount?.cardNumber == null || nonActivatedStatuses.includes(currAccount?.cardStatusId) ? true : false;
  const navigation = useNavigation();
  const activatePress = React.useCallback(() => {
    navigation.navigate(Screens.EsiaActivateCardAfterLogged, {
      'linkedAccount-id': String(currAccountId),
    });
  }, [isNeedActivation]);

  return (
    <>
      {currAccount ? (
        <View>
          <Text style={styles.h6}>ФИО:</Text>
          <Text>{`${capitalizeLastWord(currAccount.counterpartyFullName)}`}</Text>
          {isNeedActivation ? (
            <View>
              <Button
                id='confirm-request-link'
                type='primary'
                style={{
                  marginTop: 15,
                  width: '100%',
                }}
                onPress={activatePress}
                textStyle={{fontSize: 15}}
                text='Активировать'
              />
            </View>
          ) : (
            <>
              <Text style={[styles.h6, {marginTop: 16}]}>№ карты:</Text>
              <Text>{`**** **** **** ${currAccount.cardNumber}`}</Text>
            </>
          )}
          <Text style={[styles.h6, {marginTop: 16}]}>Статус подключения:</Text>
          <Text
            style={[
              {
                color:
                  _theme.linkedAccounts.statusColors[
                    ProfileLinkedAccountStatus[currAccount.status as keyof typeof ProfileLinkedAccountStatus] ||
                      ProfileLinkedAccountStatus.Pending
                  ],
              },
            ]}>
            {currAccount.status === 'Accepted' ? 'Подключен' : 'Ожидает'}
          </Text>
          {currAccount.status === 'Accepted' && currAccount.isCardHolderParent === true ? (
            <View>
              <Button
                id='confirm-request-link'
                type='secondary'
                style={{
                  marginTop: 15,
                  width: '100%',
                }}
                onPress={handleDeclineClick}
                textStyle={{fontSize: 15}}
                text='Отклонить'
              />
            </View>
          ) : null}
          <View style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
            {currAccount.status === 'Pending' && currAccount.isCardHolderParent === true ? (
              <Button
                id='confirm-request-link'
                type='primary'
                style={{
                  marginTop: 15,
                  width: '100%',
                }}
                onPress={handleAcceptLinkingAccount}
                textStyle={{fontSize: 15}}
                text='Принять'
              />
            ) : null}
            {currAccount.status === 'Pending' && currAccount.isCardHolderParent === true ? (
              <Button
                id='confirm-request-link'
                type='secondary'
                style={{
                  marginTop: 15,
                  width: '100%',
                }}
                onPress={handleDeclineClick}
                textStyle={{fontSize: 15}}
                text='Отклонить'
              />
            ) : null}
          </View>
          {(currAccount.status === 'Accepted' || currAccount.status === 'Pending') &&
          currAccount.isCardHolderParent === false ? (
            <View>
              <Button
                id='confirm-request-link'
                type='secondary'
                style={{
                  marginTop: 15,
                  width: '100%',
                }}
                onPress={handleDeclineClick}
                textStyle={{fontSize: 15}}
                text='Отклонить'
              />
            </View>
          ) : null}
        </View>
      ) : null}
    </>
  );
}
